const generateGrowthChartData = (startDate: string, endDate: string, initialValue: number) =>
    ((result: any[] = [], d = new Date(startDate), v = initialValue) => {
        while (d <= new Date(endDate)) {
            result.push({ date: d.toISOString().split('T')[0], value: v });
            v *= (1 + (Math.random() * 0.002 - 0.001)) ** 30;
            d.setMonth(d.getMonth() + 2, 0);
        }
        return result;
    })();

export const growthChartData = [
    {
        entityId: 'tmif1000-a',
        isCurrent: true,
        name: 'TMI Bond Fund V - Series A1',
        type: 'SERIES',

        // use a function to generate similar sample growth chart for a given date range (month-end values)
        values: generateGrowthChartData('2008-04-18', '2009-12-31', 10000),
    },
];

const widgetsData = {
    tableData: [
        {
            series: 'Series A',
            '1mth': '2.7',
            '3mth': '-1.8',
            '6mth': '-3.8',
            '1yr': '0.1',
            '3yr': '5.4',
            '5yr': '4.2',
            '10yr': '5.9',
            sinceInception: '8.1',
        },
        {
            series: 'Series B',
            '1mth': '6.7',
            '3mth': '5.6',
            '6mth': '1.2',
            '1yr': '-6.7',
            '3yr': '4.2',
            '5yr': '-0.9',
            '10yr': '4.9',
            sinceInception: '3.6',
        },
        {
            series: 'Series C',
            '1mth': '-0.4',
            '3mth': '0.7',
            '6mth': '-3.8',
            '1yr': '2.1',
            '3yr': '8.4',
            '5yr': '4.6',
            '10yr': '3.6',
            sinceInception: '9.0',
        },
    ],
    performance: {
        growth: growthChartData,
    },
};

export default widgetsData;
